var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkincare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H28.4C33.9229 0 38.4 4.47715 38.4 10V28C38.4 33.5228 33.9228 38 28.4 38H9.99999C4.47715 38 0 33.5228 0 28V10Z",
    fill: "#D8EAF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0001 19C20.841 19 22.3334 17.5076 22.3334 15.6666C22.3334 13.8257 20.841 12.3333 19.0001 12.3333C17.1591 12.3333 15.6667 13.8257 15.6667 15.6666C15.6667 17.5076 17.1591 19 19.0001 19Z",
    stroke: "#004276",
    strokeWidth: 0.833333
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 25.6666V24.8333C14 23.5072 14.5268 22.2355 15.4645 21.2978C16.4021 20.3601 17.6739 19.8333 19 19.8333C20.3261 19.8333 21.5979 20.3601 22.5355 21.2978C23.4732 22.2355 24 23.5072 24 24.8333V25.6666",
    stroke: "#004276",
    strokeWidth: 0.833333
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkincare);
export default __webpack_public_path__ + "static/media/skin care.2051a308d1131748b226e3dc0753e819.svg";
export { ForwardRef as ReactComponent };